import React, { useState } from 'react';
import '../styles/search.css';

interface SearchComponentProps {
  onSearch: (keywords: string, yearFrom: string, yearTo: string) => void;
  loading: boolean;
  source: 'arxiv' | 'crossref';
}

export const SearchComponent: React.FC<SearchComponentProps> = ({ onSearch, loading, source }) => {
  const [keywords, setKeywords] = useState('');
  const [yearFrom, setYearFrom] = useState('');
  const [yearTo, setYearTo] = useState('');

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 30 }, (_, i) => currentYear - i);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(keywords.trim(), yearFrom, yearTo);
  };

  const handleClear = () => {
    setKeywords('');
    setYearFrom('');
    setYearTo('');
    onSearch('', '', '');
  };

  return (
    <div className="search-container">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-input-group">
          <label htmlFor="keywords">Keywords</label>
          <input
            id="keywords"
            type="text"
            placeholder="Enter keywords (e.g., machine learning, quantum computing)"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="year-range-group">
          <div className="year-input">
            <label htmlFor="yearFrom">Year From</label>
            <select
              id="yearFrom"
              value={yearFrom}
              onChange={(e) => setYearFrom(e.target.value)}
              className="year-select"
            >
              <option value="">Any</option>
              {yearOptions.map(year => (
                <option key={year} value={year.toString()}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="year-input">
            <label htmlFor="yearTo">Year To</label>
            <select
              id="yearTo"
              value={yearTo}
              onChange={(e) => setYearTo(e.target.value)}
              className="year-select"
            >
              <option value="">Any</option>
              {yearOptions.map(year => (
                <option key={year} value={year.toString()}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="search-buttons">
          <button type="submit" disabled={loading} className="search-button search-button-primary">
            {loading ? 'Searching...' : `Search ${source === 'arxiv' ? 'arXiv' : 'CrossRef'}`}
          </button>
          <button type="button" onClick={handleClear} className="search-button search-button-secondary">
            Clear
          </button>
        </div>
      </form>
    </div>
  );
};